import $ from 'jquery';

import ScrollMagic from 'scrollmagic';
import TweenMax from 'gsap';
import TimelineMax from 'gsap/TimelineMax';
import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js';

class ParallaxHero {
	
	constructor() {
		this.doParallax();
	}

	doParallax() {
		var controller = new ScrollMagic.Controller();
		var $backgroundImage = $(".property-hero__img");
					
		var parallaxEffect = TweenMax.to( $backgroundImage, 1, {
			y: -300,
			ease: Power0.easeNone
		} );

		var parallaxScene = new ScrollMagic.Scene({
			// triggerElement: $backgroundImage,
			triggerHook: 1,
			duration: '200%',
		})
		.setTween( parallaxEffect )
		.addTo(controller);
	}

}

module.exports = ParallaxHero;